import GraphDigitizer from "./GraphDigitizer";

function App() {
  return <GraphDigitizer />;
}

export default App;